import { BlogWriterCommon } from '~/agents/blogWriter/common'
import { AgentKey } from '~/agents/common/common/types'
import { CustomerSupportCommon } from '~/agents/customerSupport/common'
import { ExecutiveAssistantCommon } from '~/agents/executiveAssistant/common'
import { LegalAssistantCommon } from '~/agents/legalAssistant/common'
import { ReceptionistCommon } from '~/agents/receptionist/common'
import { SalesAssistantCommon } from '~/agents/salesAssistant/common'
import { SocialMediaManagerCommon } from '~/agents/socialMediaManager/common'

const agentsCommon = [
  BlogWriterCommon,
  CustomerSupportCommon,
  ExecutiveAssistantCommon,
  LegalAssistantCommon,
  SalesAssistantCommon,
  SocialMediaManagerCommon,
  ReceptionistCommon,
]

const getByKey = (key: AgentKey) => {
  const agentCommon = agentsCommon.find(
    candidate => candidate.Agent.key === key,
  )

  return { agentCommon }
}

export const AgentFacade = {
  getByKey,
  agents: agentsCommon,
}
